exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h2[data-v-ec5bcb4c] {\n  text-transform: none;\n}\n@media (max-width: 1220px) {\n.two-column-list li[data-v-ec5bcb4c] {\n    width: 50%;\n}\n}\n@media (max-width: 576px) {\n.two-column-list li[data-v-ec5bcb4c] {\n    width: 100%;\n}\n}", ""]);

// exports
